import React, { useState } from "react";

export const ThemeContext = React.createContext({
  themeName: "sky",
  imageData: {
    name: "",
    description: "",
    response: ""
  },
  setThemeName: () => {},
  setImageData: () => {}
});


export const themes = {
  salmon: {
    background: "#f76d6d",
    color: "#f7e9a0"
  },
  yellow: {
    background: "#f7e9a0",
    color: "#374785"
  },
  darkBlue: {
    background: "#24315e",
    color: "#f76d6d"
  },
  aqua: {
    background: "#57dbd1",
    color: "#24315e"
  },
  sky: {
    background: "#a8d1e7",
    color: "#f76d6d"
  }
};

export const ThemeProvider = props => {
  const [themeName, setThemeName] = useState("salmon");
  const [imageData, setImageData] = useState({ name: "", description: "", response: ""})
  return (
    <ThemeContext.Provider value={{ themeName, setThemeName, imageData, setImageData }}> 
     {props.children}
    </ThemeContext.Provider>
  );
};
